import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import api from './api/axiosInstance';
import base_url from './api/Config';
import getApplicationId from './api/getApplicationId';

const Otp = () => {
  const { state } = useLocation();
  const mobileNo = state?.mobileNo || '';
  const [otp, setOtp] = useState('');
  const [timer, setTimer] = useState(90);
  const [resendDisabled, setResendDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [resendModal, setResendModal] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (timer <= 0) { setResendDisabled(false); return; }
    const interval = setInterval(() => setTimer(t => t - 1), 1000);
    return () => clearInterval(interval);
  }, [timer]);

  const handleResendOtp = async () => {
    try {
      await api.post(`${base_url}/api/login/otp/generate`, { mobileNo, otp }, {
        headers: { 'Content-Type': 'application/json' },
      });
      setTimer(90);
      setResendDisabled(true);
      setResendModal(true);
    } catch {
      setErrorModal(true);
    }
  };

  const handleLogin = async () => {
    if (!otp || otp.length < 4) { setErrorModal(true); return; }
    setIsLoading(true);
    try {
      await api.post(`${base_url}/api/login/otp/verifyLogin`, {
        mobileNo: mobileNo.toString(),
        otp: otp.toString(),
      }, { headers: { 'Content-Type': 'application/json' } });

      const findRes = await api.get(`${base_url}/api/user/findMobileNum?mobileNum=${mobileNo}`);
      const customerId = findRes.data[0]?.id;
      if (!customerId) { setErrorModal(true); return; }

      const applicationId = await getApplicationId(customerId);

      try {
        const statusRes = await api.get(`${base_url}/api/detailsMatch/statusByMobile?mobileNum=${mobileNo}`);
        const status = statusRes.data.status;
        switch (status) {
          case 'User Registered': navigate(`/Permission?id=${customerId}`); break;
          case 'Pan Verified': navigate(`/Address?applicationId=${applicationId}&customerId=${customerId}`); break;
          case 'Credit check': navigate(`/CreditCheck?applicationId=${applicationId}&customerId=${customerId}`); break;
          case 'CompleteDigiLocker': navigate(`/DocumentUpload?applicationId=${applicationId}&customerId=${customerId}`); break;
          default: navigate(`/Permission?id=${customerId}`);
        }
      } catch {
        navigate(`/Permission?id=${customerId}`);
      }
    } catch {
      setErrorModal(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="app-page" style={{ background: 'linear-gradient(160deg, #1d2e77 0%, #2a3f9d 100%)', justifyContent: 'center', alignItems: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: '32px 24px', margin: 24, boxShadow: '0 8px 32px rgba(0,0,0,0.18)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <p style={{ fontSize: 22, fontWeight: 700, color: '#1d2e77', marginBottom: 4 }}>OTP Verification</p>
          <p style={{ fontSize: 13, color: '#666' }}>Enter the OTP sent to <strong>{mobileNo}</strong></p>
        </div>

        <div className="field-group">
          <label className="field-label">OTP <span className="field-star">*</span></label>
          <input
            className="field-input"
            type="password"
            maxLength={6}
            value={otp}
            onChange={e => setOtp(e.target.value)}
            style={{ letterSpacing: 8, fontSize: 20, textAlign: 'center' }}
          />
        </div>

        <div style={{ textAlign: 'right', marginBottom: 16 }}>
          <span style={{ fontSize: 13, color: '#888' }}>
            {timer > 0 ? `Resend in ${timer}s` : ''}
          </span>
          {!resendDisabled && (
            <button onClick={handleResendOtp} style={{ background: 'none', border: 'none', color: '#1d2e77', fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>
              Resend OTP
            </button>
          )}
        </div>

        <button className="btn-primary-app" onClick={handleLogin} disabled={isLoading}>
          {isLoading ? 'Verifying...' : 'Verify & Login'}
        </button>
      </div>

      <Modal show={errorModal} onHide={() => setErrorModal(false)} centered>
        <Modal.Body className="text-center p-4">
          <strong>Invalid OTP. Please try again.</strong>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={() => setErrorModal(false)}>Close</button>
        </Modal.Footer>
      </Modal>

      <Modal show={resendModal} onHide={() => setResendModal(false)} centered>
        <Modal.Body className="text-center p-4">
          <strong>OTP sent successfully.</strong>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={() => setResendModal(false)}>OK</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Otp;
